import React from "react";

// tslint:disable: max-line-length
interface Props {
  width?: number;
  height?: number;
}
export default function Renouvellement(props: Props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={props.width ? props.width + "px" : "24px"}
      height={props.height ? props.height + "px" : "18px"}
      viewBox="0 0 18 18"
    >
      <g id="Groupe_49" data-name="Groupe 49">
        <path
          id="icon"
          d="M0,9.628A8.45,8.45,0,0,1,7.08,1.39V.27c0-.245.177-.34.392-.215l.945.553c.216.125.568.331.783.457l.946.552a.243.243,0,0,1,0,.458L9.2,2.628l-.783.457-.945.553c-.215.126-.392.03-.392-.215V2.589A7.252,7.252,0,0,0,1.211,9.628,7.3,7.3,0,0,0,8.6,16.821a7.53,7.53,0,0,0,3.753-1,.617.617,0,0,1,.83.207.581.581,0,0,1-.213.807A8.761,8.761,0,0,1,8.6,18,8.5,8.5,0,0,1,0,9.628ZM14.557,16.1l-1.407-1.37a.465.465,0,0,1,0-.67.5.5,0,0,1,.688,0l1.406,1.37a.465.465,0,0,1,0,.67.495.495,0,0,1-.688,0Zm2.065-2.659-1.832-.755a.469.469,0,0,1-.259-.621.492.492,0,0,1,.638-.252L17,12.572a.468.468,0,0,1,.259.621.488.488,0,0,1-.449.289A.5.5,0,0,1,16.622,13.445Zm-1.1-3.343a.474.474,0,1,1,0-.948h1.989a.474.474,0,1,1,0,.948Zm-.993-2.915a.47.47,0,0,1,.259-.621l1.832-.754a.491.491,0,0,1,.638.252A.469.469,0,0,1,17,6.685l-1.832.754a.494.494,0,0,1-.19.038A.487.487,0,0,1,14.531,7.187ZM13.151,5.193a.465.465,0,0,1,0-.671l1.407-1.37a.5.5,0,0,1,.688,0,.465.465,0,0,1,0,.671L13.839,5.193a.5.5,0,0,1-.688,0ZM11.1,3.848a.47.47,0,0,1-.258-.621l.775-1.784a.492.492,0,0,1,.638-.252.47.47,0,0,1,.259.621L11.741,3.6a.487.487,0,0,1-.448.29A.494.494,0,0,1,11.1,3.848Z"
          transform="translate(0 0)"
        />
      </g>
    </svg>
  );
}
